import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Button as ButtonMUI } from '@mui/material';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Row = styled('div')`
  display: flex;
  gap: 24px;

  .smallInput {
    width: 136px;
    flex-shrink: 0;
  }

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    .smallInput {
      width: 75px;
    }
  }

  @media (max-width: ${theme.breakpoints.values.md}px) {
    flex-direction: column;

    .smallInput {
      width: 100%;
    }
  }
`;

export const ButtonCollapse = styled(ButtonMUI)`
  variant: text;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px;
  margin-bottom: 12px;
  font-size: 14px;
  box-shadow: none;
  font-weight: 400;
  text-transform: none;
  text-align: left;
  &:hover {
    color: ${theme.palette.primary.focus};
  }
`;